import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import {
    IAttachmentFile,
    TelXLContentPreviewInlineComponent,
    TelXLContentPreviewService,
    TelXLSingleAttachmentsComponent,
} from '@dxp/components';
import { IMessageAttachment, IMessageHistory, Role } from '@dxp/core/models';
import { ChannelType } from '@dxp/core/types';

@Component({
    selector: 'telxl-shared-chat-history',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TelXLContentPreviewInlineComponent,
        TelXLSingleAttachmentsComponent,
    ],
    templateUrl: './chat-history.component.html',
    styleUrl: './chat-history.component.scss',
})
export class TelXLChatHistoryComponent {
    contentPreviewService = inject(TelXLContentPreviewService);

    messages = input.required<IMessageHistory[]>();
    channel = input.required<ChannelType>();

    sortedMessages = computed(() =>
        this.messages().sort((a, b) => a.createdAt.localeCompare(b.createdAt)),
    );

    messageClass(message: IMessageHistory): string {
        switch (message.from) {
            case Role.Bot:
                return 'bot-message';
            case Role.Customer:
                return 'customer-message';
            default: {
                switch (this.channel()) {
                    case 'webchat':
                    case 'email':
                    case 'voice':
                        return `agent-message ${this.channel().toLocaleLowerCase()}`;
                    default:
                        return `agent-message socials`;
                }
            }
        }
    }

    agentMessageClass = computed<string>(() => {
        switch (this.channel()) {
            case 'webchat':
            case 'email':
            case 'voice':
                return 'text-bg-' + this.channel().toLowerCase();
            default:
                return 'text-bg-socials';
        }
    });

    file(file: IMessageAttachment): IAttachmentFile {
        return {
            id: file.contentUrl ?? file.name ?? '',
            name: file.name ?? '',
            url: file.contentUrl,
            type: file.contentType ?? 'plain/text',
            size: 0,
        };
    }

    previewable(file: IMessageAttachment): boolean {
        return this.contentPreviewService.canPreview(
            file.contentType,
            file.name,
        );
    }
}
